module.exports = "<div class=\"time-pickr\">\n  <input type=\"text\" class=\"time-pickr-readonly\" [(ngModel)]=\"selectedTime\" readonly *ngIf=\"!editMode\" />\n  <div class=\"time-pickr-edit row flex-items-xs-left\" *ngIf=\"editMode\">\n    <span class=\"col-xs-6 cell-align\"><input type=\"number\" [(ngModel)]=\"selectedTimeHours\" min=\"0\" max=\"23\"/></span>\n    <span class=\"col-xs-6 cell-align\"><input type=\"number\" [(ngModel)]=\"selectedTimeMinutes\" min=\"0\" max=\"59\" /></span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dataprotection/dataprotection-common/time-picker/time-picker.html
// module id = 9jdQ
// module chunks = 0